import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LineForm2 } from "../cmp/LineForm2";
import { LineForm7Profil } from "../cmp/LineForm7profil";
import { eventBus } from "../services/eventBusService";
import { loadCrms, removeCrm, setEditCrm } from "../store/actions/crmAction";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
export function Modal7Profil({ isOpen, toggle, crmId }) {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);

  const [isShown, setIsShown] = useState(true);

  const closeModal = () => {
    setIsShown(false);
    eventBus.emit("editing");
    eventBus.emit("added");
  };

  return (
    <div //className="modal-content modal-container"
    >
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={true}
        keyboard={true}
        className="pt-1 pb-1"
      >
        <ModalHeader toggle={toggle}>{"Modifier votre Profil"}</ModalHeader>
        <ModalBody className="pt-1">
          <LineForm7Profil closeModal={toggle} />
        </ModalBody>
      </Modal>
    </div>
    /*
    <div>
      <div
        className={`modal-wrapper ${isShown ? "" : "hide"}`}
        onClick={closeModal}
      >
        <div
          className="modal-content modal-container"
          onClick={(ev) => ev.stopPropagation()}
        >
          <LineForm7Profil closeModal={closeModal} />
        </div>
      </div>
    </div>*/
  );
}
